import React from "react";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export const countryOptionCode = (option) => String(option?.iso_code || option?.code || "").toUpperCase();

export const countryOptionName = (option) => String(option?.name || option?.label || option?.value || "");

export const makeCountryOption = (country, value = undefined) => {
  const name = countryOptionName(country);
  const code = countryOptionCode(country);

  return {
    ...country,
    value: String(value ?? country?.value ?? country?.id ?? name),
    label: name,
    name,
    code,
    iso_code: code,
  };
};

export const formatCountryOptionLabel = (option, meta = {}) => {
  const name = countryOptionName(option);
  const code = countryOptionCode(option);

  if (!code) return name;
  if (meta.context === "value") return `${name} (${code})`;

  return (
    <SoftBox sx={{ lineHeight: 1.05 }}>
      <SoftTypography variant="caption" color="dark" sx={{ fontSize: "12px", lineHeight: 1.05 }}>
        {name}
      </SoftTypography>
      <SoftTypography variant="caption" color="text" display="block" sx={{ fontSize: "10px", lineHeight: 1.05 }}>
        {code}
      </SoftTypography>
    </SoftBox>
  );
};
